import Button from './button';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-inner">
                <div className="navbar-left">
                    <img className="logo-img" src={`${process.env.PUBLIC_URL}/assets/Brand_Logo.png`} alt="Vidya Sireesha - Certified Trauma Informed Therapist" />
                    <span className="brand-name">Heal With Siri</span>
                </div>
                <div className="hidden md:flex navbar-right">
                    <Link className="button-text" to="home" smooth={true} duration={500} offset={-72}>
                        Home
                    </Link>
                    <Link className="button-text" to="about-me" smooth={true} duration={500} offset={-72}>
                        About Me
                    </Link>
                    <Link className="button-text" to="booking-form" smooth={true} duration={500} offset={-72}>
                        Book Appointment
                    </Link>
                </div>
                <div className="relative flex md:hidden">
                    <Button type="text" onClick={toggleDropdown}>
                        Menu
                    </Button>
                    {dropdownVisible && (
                        <div ref={dropdownRef} className="dropdown-modal absolute top-12 right-0 bg-white shadow-card rounded-xl z-50">
                            <Link className="button-text mobile-nav-link" to="home" smooth={true} duration={500} offset={-72} onClick={toggleDropdown}>
                                Home
                            </Link>
                            <Link className="button-text mobile-nav-link" to="about-me" smooth={true} duration={500} offset={-72} onClick={toggleDropdown}>
                                About Me
                            </Link>
                            <Link className="button-text mobile-nav-link" to="booking-form" smooth={true} duration={500} offset={-72} onClick={toggleDropdown}>
                                Book Appointment
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
